import styled from 'styled-components';
export const StyledLoader = styled.div`
  color: ${(props) => props.theme.loader_text} !important;
`;